import { defineComponent, h, defineAsyncComponent } from 'vue';
import { QSelect } from 'quasar';
import utils from '../../../Shared/utils.jsx';
import Pg2FullRow from './Pg2FullRow.jsx';
import { wrapPropertyGridRow } from './pg2Wrap.jsx';

const PropertyGrid2 = defineAsyncComponent(() => import('../form/PropertyGrid2.jsx'));

export default defineComponent({
    name: 'form2-nullable-type',
    components: {
        QSelect,
        PropertyGrid2,
        Pg2FullRow,
    },
    data: () => ({
        oneofschema: null,
        list: null,
    }),
    props: {
        name: null,
        cmodel: null,
        typeSchema: null,
        form_model: null,
        child: 0,
        root: null,
        schema: null,
        path: null,
        navigateTo: null,
        canNavigate: false,
        uniquerowkey: null,
        propertygrid: false,
    },
    async created() {
        if (this.form_model && this.form_model.oneOf && this.form_model.oneOf.length == 2) {
            const s = await utils.schema.get(this.form_model.oneOf[1].$typeSchema);
            this.oneofschema = utils.schema.resolve_Of(s);
        }
        this.list = await utils.schema.get('/Apps/Schema/AnyOf/schema/public/Platform.Schema.BaseTypes.v1/SchemaSchema');
    },
    methods: {
        async changed(value) {
            const s = await utils.schema.get(value);
            this.oneofschema = utils.schema.resolve_Of(s);
            this.form_model.oneOf[1] = utils.schema.getDefaultModel(this.oneofschema);
        },
        getItemProps(item) {
            return {
                title: item.text,
                value: item.value,
                disabled: item.disabled,
            };
        },
    },
    render() {
        if (!this.list) return null;

        let element;
        if (this.form_model && this.form_model.oneOf && this.form_model.oneOf.length == 2) element = this.form_model.oneOf[1];

        const options = [];
        let value;
        let selected = false;
        for (let i = 0; i < this.list.anyOf.length; i++) {
            const opt = this.list.anyOf[i];

            if (element && element.$typeSchema === opt.Id) {
                value = opt.Id;
                selected = true;
            }
            options.push({ text: opt.title, value: opt.Id, disabled: false });
        }
        if (!selected) options.splice(0, 0, { text: 'Please select one', value: '', disabled: true });

        const typeSelect = (
            <QSelect
                borderless
                dense
                hide-bottom-space
                options={options}
                option-label="text"
                option-value="value"
                options-dense
                emit-value
                map-options
                modelValue={value}
                style={{ width: '100%', minWidth: 0 }}
                popup-content-class="q-select-max-popup-height"
                onUpdate:modelValue={(v) => this.changed(v)}
            />
        );

        let subelement;
        if (element) {
            subelement = (
                <PropertyGrid2
                    name={element.title || this.name}
                    schemakey={null}
                    root={this.root}
                    schema={this.oneofschema}
                    form={null}
                    cmodel={element}
                    child={this.child}
                    readonly={element.readonly || false}
                    navigateToModel={null}
                    canNavigate={this.canNavigate}
                    navigateTo={this.navigateTo}
                >
                </PropertyGrid2>
            );
        }

        if (this.propertygrid) {
            const typeRow = wrapPropertyGridRow(
                this,
                () => (
                    <span class="c-PropertyGrid2__labelInner" style={{ marginLeft: this.child * 15 + 'px' }}>
                        Nullable Type:
                    </span>
                ),
                () => typeSelect,
            );

            return (
                <>
                    {typeRow}
                    {element ? (
                        <Pg2FullRow>
                            <div class="c-NullableType__nestedGrid" title="Selected type properties">
                                {subelement}
                            </div>
                        </Pg2FullRow>
                    ) : null}
                </>
            );
        }

        return (
            <Pg2FullRow>
                <div style={{ verticalAlign: 'top', minWidth: 0 }} class={{ 'property-grid': this.propertygrid }}>
                    <span
                        class={{ 'property-grid': this.propertygrid }}
                        style={{
                            whiteSpace: 'nowrap',
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            minWidth: 0,
                        }}
                    >
                        Nullable Type:
                        <QSelect
                            borderless
                            dense
                            hide-bottom-space
                            options={options}
                            option-label="text"
                            option-value="value"
                            options-dense
                            emit-value
                            map-options
                            modelValue={value}
                            style={{ width: '100%', minWidth: 0, flex: '1 1 auto' }}
                            popup-content-class="q-select-max-popup-height"
                            onUpdate:modelValue={(v) => this.changed(v)}
                        />
                    </span>
                    {subelement}
                </div>
            </Pg2FullRow>
        );
    },
});
